import React, { useCallback, useContext, useState } from 'react';
import style from './style';
import ROUTES from '../../../../config/Routes';
import { useHistory } from 'react-router-dom';
import { Context } from '../../../../states/Store';
import i18next from 'i18next';
import BackButton from '../../../../components/context/FicheContext/Header/BackButton';
import FicheContextHeader from '../../../../components/context/FicheContext/Header';
import EAButton from '../../../../components/common/EAButton';
import EAIcon from '../../../../components/common/EAIcon';
import {
  archiveThirdParty,
  reactivateThirdParty,
} from '../../../../services/edge/ContexteService';
import { FormProvider, useForm } from 'react-hook-form';
import ArchiveDialog from '../../ArchiveDialog';

const FORM_ID = 'deactivation-reason-detail';

const ContextTiersHeader = ({
  context,
  selectedTp,
  fetchAssociatedTP,
}) => {
  const { classes } = style();
  const history = useHistory();
  const [state, dispatch] = useContext(Context);
  const [isArchiveOpen, setIsArchiveOpen] = useState(false);

  const methods = useForm({
    mode: 'onChange',
    delayError: 500,
    defaultValues: {
      motif: '',
    },
  });


  const close = useCallback(() => {
    history.replace(
      `/${state.account.id}/${ROUTES.CONTEXT}?instance=${context.id}`
    );
  }, [state.account.id, context.id, history]);


  const archiveTiers = useCallback(async (data) => {
      await archiveThirdParty(
        state.account.id,
        selectedTp.id,
        data,
        dispatch
      );
      await fetchAssociatedTP();
  }, [dispatch, state.account.id, fetchAssociatedTP, selectedTp]);

  const reactivateTp = useCallback(async () => {
    await reactivateThirdParty(state.account.id, selectedTp.id, dispatch);
    fetchAssociatedTP();
  }, [dispatch, state.account.id, fetchAssociatedTP, selectedTp]);


  const contextButton = useCallback(() => {
    return (
      <div
        onClick={close}
        className={classes.contextNameButton}
      >
        <EAIcon className={classes.contextIcon} icon={'context/business_center_grey'}/>
        <span className={classes.contextNameButtonText}>{context.reference}</span>
      </div>
    );
  }, [ classes, context.reference, close]);

  const archiveTierButtons = useCallback(() => {
    return (
      <>
        {selectedTp ? (
          <div className={classes.actionButtonGroup}>
            {/*   <EAButton
          onClick={(e) => {
            e.preventDefault();
            activateSupplyChain();
          }}
          content={
            <>
              <EAIcon icon={'context/activateSupplyChain'} />
              <span className={classes.buttonText}>
                {i18next.t('context.contextDetail.activateSupplyChain')}
              </span>
            </>
          }
          colorVariant={'primaryLight'}
          customStyle={{
            width: 'auto',
            height: '40px',
            marginRight: '12px',
            marginLeft: '12px',
          }}
        />*/}
            <EAButton
              onClick={(e) => {
                e.preventDefault();
                setIsArchiveOpen(true);
              }}
              content={
                <>
                  <EAIcon icon="archive_grey" />
                  <span className={classes.buttonText}>
                    {i18next.t(`context.contextDetail.archiver`)}
                  </span>
                </>
              }
              colorVariant={'secondary'}
              customStyle={{ height: '40px' }}
              disabled={selectedTp.parentIsArchived || context.isArchived}
            />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }, [selectedTp,
    classes.actionButtonGroup,
    classes.buttonText,
    context.isArchived
  ]);

  const activeTiersButtons = useCallback(() => {
    return (<>
      {selectedTp?<div className={classes.actionButtonGroup}>
        <EAButton
          onClick={(e) => {
            e.preventDefault();
            reactivateTp();
          }}
          content={
            <>
              <EAIcon icon={'play_circle_filled_green'} />
              <span className={classes.buttonText}>
                {i18next.t('context.contextDetail.activate')}
              </span>
            </>
          }
          colorVariant={'primaryLight2'}
          customStyle={{ width: 'auto', height: '40px' }}
          disabled={selectedTp.parentIsArchived || context.isArchived}
        />
      </div>:<></>}
    </>);
  }, [selectedTp, context, classes, reactivateTp]);

/*  return (
    <FicheContextHeader>
      <div className={classes.navigationGroup}>
        <BackButton
          back={close}
          title={i18next.t(`context.ficheTiers.backButtonContext`)}
        />
        {contextButton()}
      </div>
      {selectedTp && selectedTp.isArchived
        ? activeTiersButtons()
        : archiveTierButtons()}
    </FicheContextHeader>
  );*/
  return (
    <FicheContextHeader>
      <div className={classes.navigationGroup}>
        <BackButton
          back={close}
          title={i18next.t(`context.ficheTiers.backButtonContext`)}
        />
        {contextButton()}
      </div>
      {selectedTp && selectedTp.isArchived
        ? activeTiersButtons()
        : archiveTierButtons()}
      <FormProvider {...methods}>
        <ArchiveDialog
          FORM_ID={FORM_ID}
          open={isArchiveOpen}
          onClose={() => setIsArchiveOpen(false)}
          callback={archiveTiers}
          traductions={{
            title: i18next.t('context.popUpTiersArchiveTitle'),
            subTitle: i18next.t('context.popUpTiersArchiveSubTitle'),
            feedback: {
              title: i18next.t('context.contextTiersDeactivatedTitle'),
              message: i18next.t('context.contextTiersDeactivated'),
              tip: i18next.t('context.contextTiersDeactivatedTip')
            }
          }}
        />
      </FormProvider>
    </FicheContextHeader>
  );
};

export default ContextTiersHeader;
